export const headers = {
  initialHeaders: [
    {
      title: "CARGO SOLICITADO",
      field: "chargeRequested",
      child: "denomination",
      isRequisition: true,
    },
    { title: "SALARIO", field: "salary", child: null, isRequisition: false },
    {
      title: "REGIONAL",
      field: "regional",
      child: "name",
      isRequisition: true,
    },
    {
      title: "TIPO DE CONTRATO",
      field: "contractType",
      child: null,
      isRequisition: true,
    },
  ],
  otherHeaders: [
    // {
    //   title: "PERFIL DEL CARGO",
    //   field: "chargeApplicant",
    //   child: "denomination",
    //   isRequisition: true,
    // },
    // {
    //   title: "OBSERVACIONES",
    //   field: "observation",
    //   child: null,
    //   isRequisition: false,
    // },
  ],
  initialHeadersRH: [
    {
      title: "NÚMERO DE REQUISICIÓN",
      field: "requisition",
      child: null,
      isRequisition: true,
    },
    {
      title: "CARGO SOLICITADO",
      field: "chargeRequested",
      child: "denomination",
      isRequisition: true,
    },
    { title: "SALARIO", field: "salary", child: null, isRequisition: false },
    {
      title: "REGIONAL",
      field: "regional",
      child: "name",
      isRequisition: true,
    },
    {
      title: "TIPO DE CONTRATO",
      field: "contractType",
      child: null,
      isRequisition: true,
    },
    {
      title: "TIPO DE CONVOCATORIA",
      field: "callType",
      child: null,
      isRequisition: false,
    },
    { title: "ESTADO", field: "status", child: null, isRequisition: false },
  ],
  otherHeadersRH: [
    {
      title: "PROCESO",
      field: "process",
      child: "description",
      isRequisition: true,
    },
    {
      title: "CARGO DEL SOLICITANTE",
      field: "chargeApplicant",
      child: "denomination",
      isRequisition: true,
    },
    {
      title: "MOTIVO DE LA SOLICITUD",
      field: "requestReason",
      child: null,
      isRequisition: true,
    },
    {
      title: "PERSONA A REEMPLAZAR",
      field: "replaceUser",
      child: null,
      isRequisition: true,
    },
    {
      title: "MOTIVO DEL RETIRO",
      field: "retirementReason",
      child: null,
      isRequisition: true,
    },
    {
      title: "FECHA DE RETIRO",
      field: "retirementDate",
      child: null,
      isRequisition: true,
    },
    {
      title: "FECHA OPORTUNA DE INGRESO",
      field: "admissionDate",
      child: null,
      isRequisition: true,
    },
    {
      title: "FECHA DE PUBLICACIÓN",
      field: "creationDate",
      child: null,
      isRequisition: false,
    },

    // {
    //   title: "PERFIL DE CARGO",
    //   field: "status",
    //   child: null,
    //   isRequisition: false,
    // },
    // {
    //   title: "OBSERVACIONES REQ",
    //   field: "observations",
    //   child: null,
    //   isRequisition: true,
    // },
    { title: "CANTIDAD", field: "amount", child: null, isRequisition: true },
    // { title: "", field: null },
  ],
};

export const defaultSearchValues = {
  initDate: null,
  endDate: null,
  minSalary: null,
  maxSalary: null,
  contractType: null,
  regional: null,
};

export const defaultSearchValuesRH = {
  initDate: null,
  endDate: null,
  regional: null,
  chargeRequested: null,
  status: null,
};
